module.exports = "https://pm2019.reeltime.no/public/images/checkmark.65f93060.svg";